'use strict'

/**
 * @type {String}
 * @description The start tag for the account variables
 */
export const startTag = '[['

/**
 * @type {String}
 * @description The start tag for the account variables
 */
export const endTag = ']]'

/**
 * @type {Array}
 * @description A list of all the preset account variables
 */
export const presetAccountVariables = [
  { name: 'ACCOUNT', tag: 'ACCOUNT' },
  { name: 'AGENCY', tag: 'AGENCY' },
]

/**
 * @type {Array}
 * @description A list of preset lead account variables
 */
export const presetLeadFields = [
  { name: 'email', tag: 'Email' },
  { name: 'firstname', tag: 'First Name' },
  { name: 'surname', tag: 'Last Name' },
  { name: 'name', tag: 'Full Name' },
  { name: 'telephone', tag: 'International Telephone' },
  { name: 'telephone', tag: 'Telephone' },
  { name: 'mobile', tag: 'International Mobile Number' },
  { name: 'mobile', tag: 'Mobile Number' },
  { name: 'postcode', tag: 'Postcode' },
  { name: 'zipcode', tag: 'Zipcode' },
  { name: 'message', tag: 'Message' },
  { name: 'dob', tag: 'Date of Birth' },
  { name: 'url', tag: 'Website URL' },
  { name: 'sector', tag: 'Business Sector' },
  { name: 'timezone', tag: 'Timezones' },
  { name: 'countries-world', tag: 'Countries World' },
  { name: 'countries-europe', tag: 'Countries Europe' },
  { name: 'counties-uk', tag: 'Counties UK' },
  { name: 'states-us', tag: 'US States' },
  { name: 'company', tag: 'Company Name' },
  { name: 'title', tag: 'Title' },
  { name: 'job-title', tag: 'Job Title' },
  { name: 'gender', tag: 'Gender' },
]

/**
 * @type {Array}
 * @description A list of preset contact account variables
 */
export const presetContactFields = [
  { name: 'title', tag: 'Title' },
  { name: 'fullname', tag: 'Full Name' },
  { name: 'firstname', tag: 'First Name' },
  { name: 'lastname', tag: 'Last Name' },
  { name: 'jobtitle', tag: 'Job Title' },
  { name: 'email', tag: 'Email' },
  { name: 'phonenumber', tag: 'Phone Number' },
]

/**
 * @type {Array}
 * @description A list of preset survey account variables
 */
export const presetSurveyFields = [
  { name: 'name', tag: 'Name' },
  { name: 'credit', tag: 'Credits' },
  { name: 'creditvalue', tag: 'Credit Value' },
  { name: 'startdate', tag: 'Start Date' },
  { name: 'enddate', tag: 'End Date' },
  { name: 'completionlimit', tag: 'Completion Limit' },
  { name: 'url', tag: 'Survey URL' },
]

/**
 * @type {Array}
 * @description Events to emit, copied from flatpickr source
 */
export const includedDateEvents = [
  'onChange',
  'onClose',
  'onDestroy',
  'onMonthChange',
  'onOpen',
  'onYearChange',
]

/**
 * @type {Array}
 * @description Let's not emit these events by default
 */
export const excludedDateEvents = [
  'onValueUpdate',
  'onDayCreate',
  'onParseConfig',
  'onReady',
  'onPreCalendarPosition',
  'onKeyDown',
]

/**
 * @type {Array}
 * @description Default colors for the color picker
 */
export const defaultColorPickerColors = [
  '#000000',
  '#FFFFFF',
  '#FF1900',
  '#F47365',
  '#FFB243',
  '#FFE623',
  '#6EFF2A',
  '#1BC7B1',
  '#00BEFF',
  '#2E81FF',
  '#5D61FF',
  '#FF89CF',
  '#FC3CAD',
  '#BF3DCE',
  '#8E00A7',
  'rgba(0,0,0,0)',
]

/**
 * @type {Object}
 * @description This is the main configuration for the akero
 * core components, we get the config from here in all of the
 * components, as this can be extended when installing the
 * akero components into vue
 */
let config = {
  defaultUseHtml5Validation: true,
  defaultInputHasCounter: true,
  defaultTrapFocus: false,
  defaultModalCanCancel: ['escape', 'x', 'outside', 'button'],
  defaultModalScroll: null,
  defaultDialogConfirmText: null,
  defaultDialogCancelText: null,
  defaultContainerElement: null,
  defaultTooltipPosition: 'top',
  defaultToastDuration: 3000,
  defaultToastPosition: null,
  defaultSnackbarDuration: 3500,
  defaultSnackbarPosition: null,
  defaultNoticeQueue: true,
  defaultNotificationDuration: 3000,
  defaultNotificationPosition: null,
  defaultIconPrev: 'chevron-left',
  defaultIconNext: 'chevron-right',
  defaultColorPickerTheme: 'light',
  defaultRuntimeTemplate: '<div></div>',
  defaultCompilerOptions: {
    outputSourceRange: false,
    whitespace: 'preserve',
  },
}

/**
 * @param {Object} options
 * @description Overrides the default options with a new
 * configuration object
 */
export const setOptions = (options) => {
  config = options
}

/**
 * @param {Vue} Vue
 * @description Overrides the default Vue instance with a
 * new one
 */
export const setVueInstance = (Vue) => {
  VueInstance = Vue
}

export let VueInstance
export { config as default }
